
//md5加密工具
let _md5 = (function () {

    "use strict";

    //十六进制输出格式。0-小写；1-大写
    let __hex_case = 0;
    //base-64填充字符。
    let __b64pad  = "";
    //每输入字符位数。8-ASCII；16-Unicode
    let __char_bit   = 8;

    //加整数，在2^32处换行。这在内部使用16位操作来解决某些JS解释器中的错误。
    let __safe_add = function (x, y) {
        let lsw = (x & 0xFFFF) + (y & 0xFFFF);
        let msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xFFFF);
    };

    //按位向左旋转32位数字。
    let __bit_rol = function (num, cnt) {
        return (num << cnt) | (num >>> (32 - cnt));
    };

    //如果一个字符的字符串被忽略，那么就把一个字符串转换成一个字符串。
    let __str_to_binary = function (str) {
        let bin = Array();
        let mask = (1 << __char_bit) - 1;
        for(let i = 0; i < str.length * __char_bit; i += __char_bit)
            bin[i>>5] |= (str.charCodeAt(i / __char_bit) & mask) << (i%32);
        return bin;
    };

    //将一个小尾数词数组转换为字符串
    let __binary_to_str = function (bin) {
        let str = "";
        let mask = (1 << __char_bit) - 1;
        for(let i = 0; i < bin.length * 32; i += __char_bit)
            str += String.fromCharCode((bin[i>>5] >>> (i % 32)) & mask);
        return str;
    };

    //将一个小尾数词数组转换为十六进制字符串。
    let __binary_to_hex = function (binary) {
        let hex_tab = __hex_case ? "0123456789ABCDEF" : "0123456789abcdef";
        let str = "";
        for(let i = 0; i < binary.length * 4; i++)
        {
            str += hex_tab.charAt((binary[i>>2] >> ((i%4)*8+4)) & 0xF) + hex_tab.charAt((binary[i>>2] >> ((i%4)*8  )) & 0xF);
        }
        return str;
    };

    //将小尾数字数组转换为以64为基数的字符串
    let __binary_to_b64 = function (binary) {
        let tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        let str = "";
        for(let i = 0; i < binary.length * 4; i += 3)
        {
            let triplet = (((binary[i   >> 2] >> 8 * ( i   %4)) & 0xFF) << 16)
                | (((binary[i+1 >> 2] >> 8 * ((i+1)%4)) & 0xFF) << 8 )
                |  ((binary[i+2 >> 2] >> 8 * ((i+2)%4)) & 0xFF);
            for(let j = 0; j < 4; j++)
            {
                if(i * 8 + j * 6 > binary.length * 32) str += __b64pad;
                else str += tab.charAt((triplet >> 6*(3-j)) & 0x3F);
            }
        }
        return str;
    };

    //这些函数实现算法使用的四个基本操作。
    let __md5_cmn = function (q, a, b, x, s, t) { return __safe_add(__bit_rol(__safe_add(__safe_add(a, q), __safe_add(x, t)), s),b); };
    let __md5_ff = function (a, b, c, d, x, s, t) { return __md5_cmn((b & c) | ((~b) & d), a, b, x, s, t); };
    let __md5_gg = function (a, b, c, d, x, s, t) { return __md5_cmn((b & d) | (c & (~d)), a, b, x, s, t); }
    let __md5_hh = function (a, b, c, d, x, s, t) { return __md5_cmn(b ^ c ^ d, a, b, x, s, t); };
    let __md5_ii = function (a, b, c, d, x, s, t) { return __md5_cmn(c ^ (b | (~d)), a, b, x, s, t); };

    //计算一个小尾数词数组的MD5，以及一个位长度
    let __core_md5 = function (x, len) {
        /* append padding */
        x[len >> 5] |= 0x80 << ((len) % 32);
        x[(((len + 64) >>> 9) << 4) + 14] = len;

        let a =  1732584193;
        let b = -271733879;
        let c = -1732584194;
        let d =  271733878;

        for(let i = 0; i < x.length; i += 16)
        {
            let olda = a;
            let oldb = b;
            let oldc = c;
            let oldd = d;

            a = __md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
            d = __md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
            c = __md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
            b = __md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
            a = __md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
            d = __md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
            c = __md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
            b = __md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
            a = __md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
            d = __md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
            c = __md5_ff(c, d, a, b, x[i+10], 17, -42063);
            b = __md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
            a = __md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
            d = __md5_ff(d, a, b, c, x[i+13], 12, -40341101);
            c = __md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
            b = __md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

            a = __md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
            d = __md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
            c = __md5_gg(c, d, a, b, x[i+11], 14,  643717713);
            b = __md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
            a = __md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
            d = __md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
            c = __md5_gg(c, d, a, b, x[i+15], 14, -660478335);
            b = __md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
            a = __md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
            d = __md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
            c = __md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
            b = __md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
            a = __md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
            d = __md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
            c = __md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
            b = __md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

            a = __md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
            d = __md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
            c = __md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
            b = __md5_hh(b, c, d, a, x[i+14], 23, -35309556);
            a = __md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
            d = __md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
            c = __md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
            b = __md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
            a = __md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
            d = __md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
            c = __md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
            b = __md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
            a = __md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
            d = __md5_hh(d, a, b, c, x[i+12], 11, -421815835);
            c = __md5_hh(c, d, a, b, x[i+15], 16,  530742520);
            b = __md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

            a = __md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
            d = __md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
            c = __md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
            b = __md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
            a = __md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
            d = __md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
            c = __md5_ii(c, d, a, b, x[i+10], 15, -1051523);
            b = __md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
            a = __md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
            d = __md5_ii(d, a, b, c, x[i+15], 10, -30611744);
            c = __md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
            b = __md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
            a = __md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
            d = __md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
            c = __md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
            b = __md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

            a = __safe_add(a, olda);
            b = __safe_add(b, oldb);
            c = __safe_add(c, oldc);
            d = __safe_add(d, oldd);
        }

        return Array(a, b, c, d);
    };

    //计算一个密钥和一些数据的HMAC-MD5
    let __core_hmac_md5 = function (key, data) {
        let bkey = __str_to_binary(key);
        if(bkey.length > 16) bkey = __core_md5(bkey, key.length * __char_bit);

        let ipad = Array(16),
            opad = Array(16);

        for(let i = 0; i < 16; i++)
        {
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5C5C5C5C;
        }

        let hash = __core_md5(ipad.concat(__str_to_binary(data)), 512 + data.length * __char_bit);
        return __core_md5(opad.concat(hash), 512 + 128);
    };

    //实例
    let __instance = null;
    //接口类
    let Class = function () {};

    //实现单例
    let GetInstance = function () {
        if (__instance == null)
        {
            __instance = new Class();
        }
        return __instance;
    };

    //对外接口，接受字符串参数并返回十六进制或base-64编码的字符串
    Class.prototype._hex_md5 = function(s){ return __binary_to_hex(__core_md5(__str_to_binary(s), s.length * __char_bit)); };
    Class.prototype._b64_md5 = function(s){ return __binary_to_b64(__core_md5(__str_to_binary(s), s.length * __char_bit)); };
    Class.prototype._str_md5 = function(s){ return __binary_to_str(__core_md5(__str_to_binary(s), s.length * __char_bit)); };
    Class.prototype._hex_hmac_md5 = function(key, data) { return __binary_to_hex(__core_hmac_md5(key, data)); };
    Class.prototype._b64_hmac_md5 = function(key, data) { return __binary_to_b64(__core_hmac_md5(key, data)); };
    Class.prototype._str_hmac_md5 = function(key, data) { return __binary_to_str(__core_hmac_md5(key, data)); };

    //执行一个简单的自检，看看虚拟机是否正常工作
    Class.prototype._md5_vm_test = function () { return this._hex_md5("abc") === "900150983cd24fb0d6963f7d28e17f72"; };

    //返回
    return GetInstance();

})();

//导出函数
export default _md5;
